import React from 'react';
import { GetServerSidePropsContext } from 'next';

import { withAuthenticatedUser } from '@lib/user/auth';
import Compose from '@components/shared/Compose';
import LoginRegisterModalProvider
  from '@components/shared/providers/LoginRegisterModalProvider/LoginRegisterModalProvider';
import AddToBoardModalProvider
  from '@components/shared/providers/AddToBoardModalProvider/AddToBoardModalProvider';
import CreateBoardModalProvider
  from '@components/shared/providers/CreateBoardModalProvider/CreateBoardModalProvider';
import CreateProjectModalProvider
  from '@components/shared/providers/CreateProjectModalProvider/CreateProjectModalProvider';
import ExploreFeed from '@components/pages/ExploreFeed/ExploreFeed';
import { addApolloState, getApollo } from '@lib/apollo/apolloClient';
import DISCOVER_PAGE_QUERY from '@components/pages/ExploreFeed/graphql/discoverPage.graphql';
import ROOM_TYPE_QUERY from '@graphql/Room/queries/get-room-types.graphql';
import ShareModalProvider from '@components/shared/providers/ShareModalProvider/ShareModalProvider';
import ExploreProductModalProvider
  from '@components/shared/providers/ExploreProductModalProvider/ExploreProductModalProvider';
import { slugRedirects } from '@lib/getSlug/getSlug';

const ExploreFeedPage = (props: any) => (
  <Compose
    components={[
      LoginRegisterModalProvider,
      ShareModalProvider,
      CreateBoardModalProvider,
      CreateProjectModalProvider,
      AddToBoardModalProvider,
      ExploreProductModalProvider,
      [ExploreFeed as any, { ...props }],
    ]}
  />
);

export default ExploreFeedPage;

export const getServerSideProps = withAuthenticatedUser(async ({
  user,
}, args) => {
  const { query: { slug } }: GetServerSidePropsContext = args;

  if (slug && typeof slug === 'string' && slugRedirects[slug]) {
    return {
      redirect: {
        destination: `/exp/${slugRedirects[slug]}`,
        statusCode: 301,
      },
    };
  }

  const apolloClient = getApollo({ cacheEnabled: true });
  const queryVariables = {
    pageNumber: 1,
    pageSizeBoards: 39,
    slug,
  };

  const [{ data }, { data: { roomTypes } }] = await Promise.all([
    apolloClient.query({
      query: DISCOVER_PAGE_QUERY,
      variables: queryVariables,
      errorPolicy: 'all',
    }),
    apolloClient.query({ query: ROOM_TYPE_QUERY })
  ]);

  const discoverPage = data?.discoverPage || null;

  if (!discoverPage) {
    return {
      notFound: true,
    };
  }

  return addApolloState(apolloClient, {
    props: {
      user,
      initialBoards: discoverPage?.boards?.items || [],
      blogPosts: discoverPage?.blogPosts || [],
      discoverPage,
      queryVariables,
      roomTypes,
    },
  });
}, {
  requireAuth: false,
});
